export default __webpack_public_path__ + "static/media/image12.b98ff898.png";